<template>
  <div
      class="widget-card"
      :class="widgetCardClass"
      :style="{order: priority}"
  >
    <WidgetCardHeader :is-warning-type="isWarningType" :icon-name="iconName"/>

    <slot v-bind="this.$props"></slot>

    <WidgetCardFooter
        :copy-link-button="copyLinkButton"
        :action-button="actionButton"
        :to="to"
        v-show="!isLoading"
    />

  </div>
</template>

<script>
import WidgetCardHeader from '@/views/Dashboard/WidgetCard/share/Header.vue';
import WidgetCardFooter from '@/views/Dashboard/WidgetCard/share/Footer.vue';

const WIDGET_CARD_TYPE_DEFAULT = 'WIDGET_CARD_TYPE_DEFAULT';
export const WIDGET_CARD_TYPE_WARNING = 'WIDGET_CARD_TYPE_WARNING';

export default {
  name: 'WidgetCard',
  components: {
    WidgetCardHeader,
    WidgetCardFooter,
  },
  props: {
    priority: {
      type: Number,
      default: 0,
    },
    widgetClass: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    widgetType: {
      type: String,
      default: WIDGET_CARD_TYPE_DEFAULT,
    },
    iconName: {
      type: String,
      default: null,
    },
    warning: {
      title: {
        type: String,
        default: null,
      },
      text: {
        type: String,
        default: null,
      },
      titleBold: {
        type: Boolean,
        default: true,
      },
      textBold: {
        type: Boolean,
        default: true,
      },
      border: {
        type: Boolean,
        default: true,
      },
    },
    subtitleLink: {
      subtitle: {
        type: String,
        default: null,
      },
      link: {
        type: String,
        default: null,
      },
    },
    copyLinkButton: {
      links: {
        type: Array,
        default: null,
      },
    },
    actionButton: {
      text: {
        type: String,
        default: null,
      },
    },
    stat: {
      title: String,
      helpText: String,
      items: Array,
    },
    bullets: {
      type: Array,
      default: null,
    },
    to: {
      name: {
        type: String,
        default: null,
      },
    },
    paymentCard: {
      daysUntilExpiration: {
        type: String,
        default: null,
      },
      number: {
        type: String,
        default: null,
      },
    },
    expireText: {
      type: String,
      default: null,
    },
    articles: {
      type: Array,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    widgetCardClass() {
      let widgetCardClass = this.widgetClass;
      if (this.isWarningType) {
        widgetCardClass += ' widget-card-warning';
      }
      if (this.isLoading) {
        widgetCardClass += ' widget-card-loading';
      }
      return widgetCardClass;
    },
    isWarningType() {
      return this.widgetType === WIDGET_CARD_TYPE_WARNING;
    },
  },
  methods: {
    getTextHtml(text) {
      return text.replace(/\n/g, '<div class="widget-card-spacer"></div>');
    },
  },
};
</script>

<style lang="stylus" scoped>
.widget-card {
  width: 400px;
  height: 400px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 22.4px;
  box-shadow: 0 4px 20px 0 #9CADAD33;
  color: #525F66;
  @media (max-width 1170px) {
    padding: 20px;
    width: 290px;
    height: 380px;
  }
  @media (max-width 768px) {
    width: 340px;
  }
  @media (max-width 747px) {
    width: 270px;
  }
  @media (max-width 600px) {
    width: 100%;
    height: 335px;
  }
  @media (max-width 480px) {
    padding: 18px;
    line-height: 19.2px;
  }
  &:hover {
    box-shadow: 0 4px 30px 0 #00000080;
  }
  &.widget-card-warning {
    border-color: #DE4B4B;
    border-width: 3px;
    border-style: solid;
    @media (max-width 480px) {
      border-width: 2px;
    }
  }
  &.widget-card-loading {
    position: relative;
  }
}

::v-deep .widget-card-content {
  margin-top: 10px;
  @media (max-width 768px) {
    margin-top: 20px;
  }
  @media (max-width 480px) {
    margin-top: -2px;
  }
}

::v-deep .widget-card-content .content-title {
  font-size: 24px;
  font-weight: 700;
  line-height: 33.6px;
  margin: 0;
  @media (max-width 1170px) {
    font-size: 20px;
    line-height: 28px;
  }
  @media (max-width 480px) {
    font-size: 18px;
    line-height: 25.2px;
    width: 258px;
  }
}

::v-deep  .widget-card-description {
  margin-top: 10px;
}
</style>
